import ActiveLinkIcon from '@Assets/icons/menu-active-link.svg';
import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { twMerge } from 'tailwind-merge';

interface DesktopSideBarItemProps {
  routeName: string;
  isActive: boolean;
  isPrevious: boolean;
}

export const DesktopSideBarItem = ({
  routeName,
  isActive,
  isPrevious,
}: DesktopSideBarItemProps) => {
  return (
    <li key={routeName}>
      <div className='flex items-center gap-[8px] p-[8px]'>
        {isActive && <img className='w-[24px]' src={ActiveLinkIcon} alt='active' />}
        <Heading.H9
          fontWeight={FontWeight.MEDIUM}
          className={`${twMerge(
            isPrevious && '!text-text-main-disabled',
            isActive && 'text-text-brand-primary',
            !isPrevious && !isActive && 'text-text-main-secondary'
          )}`}>
          {routeName}
        </Heading.H9>
      </div>
    </li>
  );
};
